
export const LOCATION_GROUP_NAMES = {
  'local-shops': 'Local Shops',
  'sunday-market': 'Sunday Market',
  'supermarket': 'Supermarket',
  'ecommerce': 'Ecommerce',
  'distribution-center': 'Distribution Center',
  'farm-prices': 'Farm Prices',
  'chipchip-sales': 'ChipChip Sales (API)',
  'chipchip-sales-db': 'ChipChip Sales (Database)',
};

// Define the display order for location groups
export const LOCATION_GROUP_ORDER = [
  'local-shops',
  'sunday-market',
  'supermarket',
  'ecommerce',
  'distribution-center',
  'farm-prices',
  'chipchip-sales',
  'chipchip-sales-db'
];
